<template>
    <div class="logistics-info">
        <el-form ref="form" :model="formData" label-width="100px">
            <el-form-item label="中文名">
                <el-input v-model="formData.chineseName"></el-input>
            </el-form-item>

            <el-form-item label="英文名">
                <el-input v-model="formData.englishName"></el-input>
            </el-form-item>

            <el-form-item label="海关编号">
                <el-input v-model="formData.customsCode"></el-input>
            </el-form-item>

            <el-form-item label="申报价">
                <el-input v-model="formData.declaredValue"></el-input>
            </el-form-item>

            <el-form-item label="重量">
                <el-input v-model="formData.weight"></el-input>
            </el-form-item>

            <el-form-item label="体积">
                <div class="volume-inputs">
                    <el-input v-model="formData.length" placeholder="长"></el-input>
                    <span class="multiply">×</span>
                    <el-input v-model="formData.width" placeholder="宽"></el-input>
                    <span class="multiply">×</span>
                    <el-input v-model="formData.height" placeholder="高"></el-input>
                </div>
            </el-form-item>

            <el-form-item label="特殊属性">
                <el-checkbox-group v-model="formData.specialProperties">
                    <el-checkbox label="含电">含电</el-checkbox>
                    <el-checkbox label="纯电">纯电</el-checkbox>
                    <el-checkbox label="液体">液体</el-checkbox>
                    <el-checkbox label="粉末">粉末</el-checkbox>
                    <el-checkbox label="膏体">膏体</el-checkbox>
                    <el-checkbox label="带磁">带磁</el-checkbox>
                    <el-checkbox label="纺织品">纺织品</el-checkbox>
                </el-checkbox-group>
            </el-form-item>
        </el-form>

        <div class="channel-table">
            <div class="section-title">渠道添加</div>
            <el-table :data="channelData" border>
                <el-table-column label="序号" type="index" width="80"></el-table-column>
                <el-table-column label="国家" prop="country"></el-table-column>
                <el-table-column label="渠道商" prop="provider"></el-table-column>
                <el-table-column label="渠道名称" prop="name"></el-table-column>
                <el-table-column label="时效" prop="timeEffect"></el-table-column>
                <el-table-column label="头程" prop="firstMile"></el-table-column>
                <el-table-column label="操作" width="80">
                    <template slot-scope="scope">
                        <el-button type="text" @click="handleDeleteChannel(scope.row)">移除</el-button>
                    </template>
                </el-table-column>
            </el-table>

            <el-button type="text" icon="el-icon-plus" @click="handleAddChannel">添加</el-button>
        </div>
    </div>
</template>

<script>
export default {
    name: 'LogisticsInfo',
    data() {
        return {
            formData: {
                chineseName: '',
                englishName: '',
                customsCode: '',
                declaredValue: '',
                weight: '',
                length: '',
                width: '',
                height: '',
                specialProperties: []
            },
            channelData: []
        }
    },
    methods: {
        handleDeleteChannel(row) {
            // 处理删除渠道逻辑
        },
        handleAddChannel() {
            // 处理添加渠道逻辑
        }
    }
}
</script>

<style lang="scss" scoped>
.volume-inputs {
    display: flex;
    align-items: center;

    .multiply {
        margin: 0 10px;
    }
}
</style>